"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var l = require("lenovo");
var Lmd = l.DTM.Lmd, Common = l.Common, RealmType = l.RealmType;
var BrowseComponentType = l.BrowseComponentType;
var createClass = require("create-react-class");
var SlickType;
(function (SlickType) {
    SlickType[SlickType["Types"] = 0] = "Types";
    SlickType[SlickType["Series"] = 1] = "Series";
    SlickType[SlickType["SubSeries"] = 2] = "SubSeries";
    SlickType[SlickType["MT"] = 3] = "MT";
})(SlickType || (SlickType = {}));
// the data
var app;
// browser slick options for home page
var bsHomeSlickConfig = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    centerMode: false,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 6,
                dots: false
            }
        },
        {
            breakpoint: 1220,
            settings: {
                slidesToShow: 5,
                dots: false
            }
        },
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 4,
                dots: false
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 3,
                dots: false
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 2,
                dots: false
            }
        }
    ]
};
// browser slick options for caps page
var bsCapsSlickConfig = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    centerMode: false,
    variableWidth: false,
    responsive: [
        {
            breakpoint: 840,
            settings: {
                slidesToShow: 3,
                dots: false
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                dots: false
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                dots: false
            }
        }
    ]
};
// the data logic
var bsApp = function (data) {
    var typesListener = {};
    var seriesListener = {};
    var subSeriesListener = {};
    var MTListener = {};
    var selectedTypes = "";
    var selectedSeries = "";
    var selectedSubSeries = "";
    var selectedMT = "";
    var selectedTypes_text = "";
    var selectedSeries_text = "";
    var selectedSubSeries_text = "";
    var selectedMT_text = "";
    var products = data;
    var currentRelam = function () {
        var currentRealm = Common.getCurrentRealm();
        var array = new Array();
        if (currentRealm === 2) {
            array = ['4F17B2FC-75C9-454A-836E-BE95E4F89B1A', '748D78D3-8FF6-4753-A981-686807A39479', '5EE324A9-D534-4F18-93EB-D65857B7BB54', 'DA3EE264-1739-5A74-21AD-6073BCA8617B', '9F7C6031-B3EF-4B9C-AA60-404285C16BA4', 'E599F87A-43E3-4AEE-9AE2-52F088BB6E87'];
        }
        // else {
        //     array = ['8C51CB37-5B79-381E-06E2-06DDA328BABB', '05950D53-B078-30A8-B339-37764245F8D7', '1EC65890-C14D-1E3D-119D-907D77EA3BE2', '9F7C6031-B3EF-4B9C-AA60-404285C16BA4', '9F7C6031-B3EF-4B9C-AA60-404285C16BA4', '1AF12AB2-7C9C-8E06-F365-334EE1A35F3C', '577A1518-C921-4F70-9FE8-3C324D35CE74', '2DCAA015-C0AA-4B7D-823C-13E85C454E72', '2DCAA015-C0AA-4B7D-823C-13E85C454E72', '3C08E076-17AA-46A2-8EEB-2C845AB9909D', 'E599F87A-43E3-4AEE-9AE2-52F088BB6E87', '339E8F3F-BAD4-4F7D-BDAA-5E6C1DD8827E', '339E8F3F-BAD4-4F7D-BDAA-5E6C1DD8827E', '748D78D3-8FF6-4753-A981-686807A39479', '4F17B2FC-75C9-454A-836E-BE95E4F89B1A', 'F9F5B92F-D070-41A8-8E3A-D06696CF5A1B', 'BADC014C-E91A-4695-9DA2-D3F45C044270', '5EE324A9-D534-4F18-93EB-D65857B7BB54', 'FFB7805D-88E5-4840-A65A-E9D6273569BD'];
        // }
        return array;
    };
    var productTypes = (function () {
        var array = $.grep(products, function (item) { return (item.Type === l.ProductType.Group); });
        var currentRealm = Common.getCurrentRealm();
        var detailRealms = Common.getRealmsDetail();
        if (currentRealm === 2) {
            var currentBrands = detailRealms[currentRealm] && detailRealms[currentRealm].brands ? detailRealms[currentRealm].brands : ["TABLET", "TPG", "IPG"];
            if (currentBrands.length > 0) {
                array = $.grep(array, function (item) { return $.inArray(item.Brand, currentBrands) >= 0; });
            }
        }
        array.sort(function (a, b) {
            return b.Popularity - a.Popularity;
        });
        return array;
    })();
    var getChildren = function (id) {
        var result = [];
        if (id) {
            result = $.grep(data, function (item) { return (item.ParentID === id); });
            result.sort(function (a, b) {
                return a.Name.toLocaleLowerCase().localeCompare(b.Name.toLocaleLowerCase());
            });
        }
        return result;
    };
    var getChildrenCount = function (id) {
        if (id) {
            var children = $.grep(data, function (item) { return (item.ParentID === id); });
            if (children && children.length) {
                return children.length;
            }
        }
        return 0;
    };
    var setSelectedTypes = function (value) {
        this.selectedTypes = value;
        this.selectedSeries = "";
        this.selectedSeries_text = "";
        this.selectedSubSeries = "";
        this.selectedSubSeries_text = "";
        this.selectedMT = "";
        this.selectedMT_text = "";
        this.seriesListener.changed();
        this.subSeriesListener.changed();
        this.MTListener.changed();
    };
    var setSelectedSeries = function (value, name) {
        this.selectedSeries = value;
        this.selectedSeries_text = name;
        this.selectedSubSeries = "";
        this.selectedSubSeries_text = "";
        this.selectedMT = "";
        this.selectedMT_text = "";
        this.subSeriesListener.changed();
        this.MTListener.changed();
    };
    var setSelectedSubSeries = function (value, name) {
        this.selectedSubSeries = value;
        this.selectedSubSeries_text = name;
        this.selectedMT = "";
        this.selectedMT_text = "";
        this.MTListener.changed();
    };
    var setSelectedMT = function (value, name) {
        this.selectedMT = value;
        this.selectedMT_text = name;
    };
    var reset = function () {
        this.selectedTypes = "";
        this.selectedSeries = "";
        this.selectedSeries_text = "";
        this.selectedSubSeries = "";
        this.selectedSubSeries_text = "";
        this.selectedMT = "";
        this.selectedMT_text = "";
        this.typesListener.changed();
        this.seriesListener.changed();
        this.subSeriesListener.changed();
        this.MTListener.changed();
    };
    return {
        productTypes: productTypes,
        getChildren: getChildren,
        getChildrenCount: getChildrenCount,
        typesListener: typesListener,
        reset: reset,
        seriesListener: seriesListener,
        subSeriesListener: subSeriesListener,
        MTListener: MTListener,
        selectedTypes: selectedTypes,
        selectedSeries: selectedSeries,
        selectedSeries_text: selectedSeries_text,
        selectedSubSeries: selectedSubSeries,
        selectedSubSeries_text: selectedSubSeries_text,
        selectedMt: selectedMT,
        selectedMT_text: selectedMT_text,
        setSelectedTypes: setSelectedTypes,
        setSelectedSeries: setSelectedSeries,
        setSelectedSubSeries: setSelectedSubSeries,
        setSelectedMT: setSelectedMT
    };
};
var setCorrectPosition = function (element, browserType) {
    if (browserType === BrowseComponentType.Home) {
        if ($(window).width() > 750) {
            var nth = Math.floor($(".prods-module").width() / 214 - 1);
            var itemnum = $(element).find(".prods-module").children('.prod-item').length - 1;
            if (nth > itemnum) {
                nth = itemnum;
            }
            if ($(element).find(".prods-module").find('.dropdown-group').length) {
                $(element).find(".dropdown-group").children(".wrapper-dropdown").removeClass("active");
                $(element).find(".ps-browse").append($(element).find(".dropdown-group"));
            }
            if ($(".prod-item.active").index() <= nth) {
                //$(element).find(".prods-module > div:eq(5)").after($(element).find(".dropdown-group"));
                $(element).find(".prods-module > div:eq(" + nth + ")").after($(element).find(".dropdown-group"));
            }
            else if ($(".prod-item.active").index() > nth) {
                $(element).find(".prods-module > div:eq(" + itemnum + ")").after($(element).find(".dropdown-group"));
            }
        }
        if ($(document).width() <= 750) {
            if ($(element).find(".prods-module").find('.dropdown-group').length) {
                $(element).find(".dropdown-group").children(".wrapper-dropdown").removeClass("active");
                $(element).find(".ps-browse").append($(element).find(".dropdown-group"));
            }
            var index = $(".prod-item.active").index();
            var isEven = index % 2 == 0 ? true : false;
            isEven = (index === $(element).find(".prods-module > div").length) ? false : isEven;
            $(element).find(".prods-module > div:eq(" + (isEven ? (index + 1) : index) + ")").after($(element).find(".dropdown-group"));
        }
    }
    $(element).find('.dropdown-group').slideDown();
};
// browser render
var bsRender = function (element, browserType, redirctTabName, redirctTabSubUrl) {
    if (redirctTabName === void 0) { redirctTabName = ""; }
    if (redirctTabSubUrl === void 0) { redirctTabSubUrl = ""; }
    var SlickList = createClass({
        getInitialState: function () {
            return {
                app: app
            };
        },
        componentWillMount: function () {
            if (this.props.slickType === SlickType.Types) {
                this.state.app.typesListener = this;
            }
        },
        componentDidMount: function () {
            if ($(this.refs.prodsModule)) {
                if (browserType === BrowseComponentType.Home) {
                    //$(this.refs.prodsModule).slick(bsHomeSlickConfig);
                }
                else {
                    $(this.refs.prodsModule).slick(bsCapsSlickConfig);
                }
            }
        },
        componentWillUpdate: function () {
            if ($(this.refs.prodsModule)) {
                $(this.refs.prodsModule).find(".prod-item").removeClass("active");
                $(this.refs.prodsModule).find(".prod-item").removeClass("dimmed");
                if (browserType === BrowseComponentType.Caps) {
                    $(this.refs.prodsModule).slick("unslick");
                }
            }
        },
        componentDidUpdate: function () {
            if ($(this.refs.prodsModule)) {
                if (browserType === BrowseComponentType.Home) {
                    //$(this.refs.prodsModule).slick(bsHomeSlickConfig);
                }
                else {
                    $(this.refs.prodsModule).slick(bsCapsSlickConfig);
                }
            }
        },
        changed: function () {
            this.forceUpdate();
        },
        onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $this = $(e.currentTarget);
            var id = $this.attr("data-value");
            $this.parent().find(".prod-item").removeClass("active");
            $this.parent().find(".prod-item").addClass("dimmed");
            $this.removeClass("dimmed");
            $this.addClass("active");
            setCorrectPosition(element, browserType);
            $(element).find('.dropdown-group').slideDown();
            if (this.props.slickType === SlickType.Types) {
                this.state.app.setSelectedTypes(id);
            }
        },
        getProducts: function (st) {
            var result = [];
            var app = this.state.app;
            if (st === SlickType.Types) {
                result = app.productTypes;
            }
            else if (st === SlickType.Series) {
                result = app.getChildren(app.selectedTypes);
            }
            else if (st === SlickType.SubSeries) {
                result = app.getChildren(app.selectedSeries);
            }
            return result;
        },
        render: function () {
            var _this_1 = this;
            var app = this.state.app;
            var products = this.getProducts(this.props.slickType);
            var productList = [];
            if (products && products.length) {
                products.forEach(function (product) {
                    var relamBelong = window["config"].realms[product.Brand].Id.replace(/realm\./i, "").toLowerCase();
                    var globalStorePath = "global/caps/" + (relamBelong === "all" ? "global" : relamBelong);
                    var storeDir = Common.getCurrentRealm() === RealmType.All ? globalStorePath : RealmType[Common.getCurrentRealm()].toLowerCase();
                    var image = "/msa/mse/images/" + storeDir + "/" + product.Id + ".png";
                    var background = "url('" + image.toLocaleLowerCase() + "') center top / contain no-repeat";
                    var divStyle = {
                        background: background,
                    };
                    productList.push(React.createElement("div", { className: "prod-item", "data-value": product.ProductGuid, onClick: _this_1.onClick },
                        React.createElement("div", { className: "prod-type", style: divStyle }),
                        React.createElement("div", { className: "product-label" }, product.Name)));
                });
                return (React.createElement("div", { className: "prods-module prods-types", ref: "prodsModule" }, productList));
            }
            return (React.createElement("div", null));
        }
    });
    var DownloadList = createClass({
        getDefaultProps: function () {
            return {
                tabName: "",
                tabSubUrl: "",
            };
        },
        getInitialState: function () {
            return {
                app: app,
                currentType: '',
                inputKey: "",
                needFilter: false
            };
        },
        componentWillMount: function () {
            if (this.props.slickType === SlickType.Series) {
                this.state.app.seriesListener = this;
                this.state.currentType = l.Translator.translate("Select Series|Select Series");
            }
            else if (this.props.slickType === SlickType.SubSeries) {
                this.state.app.subSeriesListener = this;
                this.state.currentType = l.Translator.translate("Select Sub Series|Select Sub-Series");
            }
            else if (this.props.slickType === SlickType.MT) {
                this.state.app.MTListener = this;
                this.state.currentType = l.Translator.translate("Select Machine Type|Select Machine Type");
            }
        },
        componentDidMount: function () {
            if ($(this.prodsModule)) {
            }
        },
        componentWillUpdate: function () {
            if (this.props.slickType === SlickType.Series) {
                this.state.currentType = this.state.app.selectedSeries_text === '' ? l.Translator.translate("Select Series|Select Series") : this.state.app.selectedSeries_text;
            }
            else if (this.props.slickType === SlickType.SubSeries) {
                this.state.currentType = this.state.app.selectedSubSeries_text === '' ? l.Translator.translate("Select Sub Series|Select Sub-Series") : this.state.app.selectedSubSeries_text;
            }
            else if (this.props.slickType === SlickType.MT) {
                this.state.currentType = this.state.app.selectedMT_text === '' ? l.Translator.translate("Select Machine Type|Select Machine Type") : this.state.app.selectedMT_text;
            }
        },
        componentDidUpdate: function () {
            if (this.products && this.products.length === 1) {
                var $currentLi = $(this.ddlWrapper).find("ul.list-unstyled>li:first");
                var $ddlWrapper = $(this.ddlWrapper);
                $ddlWrapper.find("ul").slideUp();
                $ddlWrapper.removeClass('active');
                var id = $currentLi.attr("data-value");
                var productid = $currentLi.attr("data-fullid");
                var brand = $currentLi.attr("data-product-brand");
                var productName = this.products[0]["Name"];
                var params = { "linkTrack": Lmd.dicLinkTrackType["CapsBrowseProduct"] };
                if (this.props.tabName)
                    params["tabName"] = this.props.tabName;
                if (this.props.tabSubUrl)
                    params["subUrl"] = this.props.tabSubUrl;
                if (this.props.slickType === SlickType.Series) {
                    var childrenCount = this.state.app.getChildrenCount(id);
                    if (childrenCount > 0) {
                        this.state.app.setSelectedSeries(id, productName);
                    }
                    else {
                        this.redirectSpecial($currentLi, productid, brand, params);
                    }
                }
                else if (this.props.slickType === SlickType.SubSeries) {
                    var parentid = productid.substring(0, productid.lastIndexOf('/'));
                    var RemoveMT = "Servers/ThinkServer";
                    if (parentid.toLocaleUpperCase() === RemoveMT.toLocaleUpperCase()) {
                        var result = {
                            id: productid,
                            brand: brand
                        };
                        l.LitePageLoader.capsRun($currentLi, result, $.extend({}, params));
                    }
                    else {
                        var childrenCount = this.state.app.getChildrenCount(id);
                        if (childrenCount > 0) {
                            this.state.app.setSelectedSubSeries(id, $currentLi.text());
                        }
                        else {
                            this.redirectSpecial($currentLi, productid, brand, params);
                        }
                    }
                }
                else if (this.props.slickType === SlickType.MT) {
                    this.redirectSpecial($currentLi, productid, brand, params);
                }
            }
        },
        changed: function () {
            this.forceUpdate();
        },
        redirectDirect: function (eventCurrentTarget, productFullId, brand, params) {
            var result = {
                id: productFullId,
                brand: brand
            };
            l.DTM.Lmd.unifiedBrowseProductTrack(productFullId);
            l.LitePageLoader.capsRun($(eventCurrentTarget), result, $.extend({}, params));
        },
        redirectSpecial: function (eventCurrentTarget, productFullId, brand, params) {
            var browsePCGSpecialObj = window["BrowsePCGSpecialProductConfig"];
            var isPCGSpecialProduct = browsePCGSpecialObj && browsePCGSpecialObj["regex"]
                && browsePCGSpecialObj["regex"] instanceof RegExp && browsePCGSpecialObj["regex"].test(productFullId);
            var hasPCGSpecialRedirectFunc = browsePCGSpecialObj && browsePCGSpecialObj["redirect"]
                && typeof browsePCGSpecialObj["redirect"] === "function";
            if (browsePCGSpecialObj && isPCGSpecialProduct && hasPCGSpecialRedirectFunc) {
                l.DTM.Lmd.unifiedBrowseProductTrack(productFullId);
                window.location.href = browsePCGSpecialObj["redirect"](productFullId);
            }
            else {
                this.redirectDirect($(eventCurrentTarget), productFullId, brand, params);
            }
        },
        onClick: function (e) {
            //debugger;
            e.preventDefault();
            e.stopPropagation();
            var $this = $(e.currentTarget);
            $this.parent('ul').slideUp().parent('div').removeClass('active');
            var id = $this.attr("data-value");
            var productid = $this.attr("data-fullid");
            var brand = $this.attr("data-product-brand");
            this.forceUpdate();
            var params = { "linkTrack": Lmd.dicLinkTrackType["CapsBrowseProduct"] };
            if (this.props.tabName)
                params["tabName"] = this.props.tabName;
            if (this.props.tabSubUrl)
                params["subUrl"] = this.props.tabSubUrl;
            if (this.props.slickType === SlickType.Series) {
                var childrenCount = this.state.app.getChildrenCount(id);
                if (childrenCount > 0) {
                    this.state.app.setSelectedSeries(id, $this.text());
                }
                else {
                    this.redirectSpecial($this, productid, brand, params);
                }
            }
            else if (this.props.slickType === SlickType.SubSeries) {
                var parentid = productid.substring(0, productid.lastIndexOf('/'));
                var RemoveMT = "Servers/ThinkServer";
                if (parentid.toLocaleUpperCase() === RemoveMT.toLocaleUpperCase()) {
                    this.redirectDirect($this, productid, brand, params);
                }
                else {
                    var childrenCount = this.state.app.getChildrenCount(id);
                    if (childrenCount > 0) {
                        this.state.app.setSelectedSubSeries(id, $this.text());
                    }
                    else {
                        this.redirectSpecial($this, productid, brand, params);
                    }
                }
            }
            else if (this.props.slickType === SlickType.MT) {
                this.redirectSpecial($this, productid, brand, params);
            }
        },
        showList: function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $this = $(e.currentTarget);
            if ($this.parent().children('ul').is(':hidden')) {
                $this.parent().addClass('active').children('ul').slideDown();
            }
            else {
                $this.parent().removeClass('active').children('ul').slideUp();
            }
        },
        handleSearch: function (e) {
            var newV = e.target.value;
            var oldV = this.state.inputKey;
            this.state.needFilter = false;
            this.state.inputKey = newV;
            this.forceUpdate();
        },
        getProducts: function (st) {
            var result = [];
            var filterResult = [];
            var app = this.state.app;
            if (st === SlickType.Types) {
                result = app.productTypes;
            }
            else if (st === SlickType.Series) {
                result = app.getChildren(app.selectedTypes);
            }
            else if (st === SlickType.SubSeries) {
                result = app.getChildren(app.selectedSeries);
            }
            else if (st === SlickType.MT) {
                result = app.getChildren(app.selectedSubSeries);
            }
            var _this = this;
            filterResult = result.filter(function (value, index, array) {
                if (value.Name) {
                    return value.Name.toLocaleUpperCase().indexOf(_this.state.inputKey.toLocaleUpperCase()) > -1;
                }
                else {
                    return false;
                }
            });
            return filterResult;
        },
        noProductResultMoreText: function () {
            var placeholderText = "";
            if (l.CultureUtility.getCurrentLanguage() === "ja" || l.CultureUtility.getCurrentCountry() === "jp") {
                placeholderText = l.Translator.translate("browse eos content|Looking for older product? Visit our {0} page!").format("<a href='https://download.lenovo.com/eol/JP/index.html' target='_blank'>" + l.Translator.translate('end of support|End of Support') + "</a>");
            }
            else {
                placeholderText = l.Translator.translate("browse eos content|Looking for older product? Visit our {0} page!").format("<a href='https://download.lenovo.com/eol/index.html' target='_blank'>" + l.Translator.translate('end of support|End of Support') + "</a>");
            }
            return placeholderText;
        },
        render: function () {
            var _this_1 = this;
            var app = this.state.app;
            var products = this.getProducts(this.props.slickType);
            this.products = products;
            var productList = [];
            if (products && (products.length || (products.length == 0 && this.state.inputKey))) {
                products.forEach(function (product) {
                    var tproduct_Name = product.Name;
                    if (_this_1.props.slickType === SlickType.MT && product.Name.split('-').length >= 2) {
                        var temp_product_name = product.Name.split('-')[product.Name.split('-').length - 1];
                        if (temp_product_name.indexOf("Type") > 0) {
                            tproduct_Name = temp_product_name;
                        }
                    }
                    productList.push(React.createElement("li", { "data-value": product.ProductGuid, "data-fullid": product.Id, "data-product-brand": product.Brand, onClick: _this_1.onClick },
                        React.createElement("span", null, tproduct_Name)));
                });
                return (React.createElement("div", { className: "wrapper-dropdown dropdown-active", ref: function (com) { _this_1.ddlWrapper = com; } },
                    React.createElement("span", { onClick: this.showList }, products.length > 1 || products.length < 1 ? this.state.currentType : products[0].Name),
                    React.createElement("ul", { className: "list-unstyled" },
                        React.createElement("div", { class: "filter-product-div" },
                            React.createElement("input", { type: "text", class: "filter-product-input", defaulValue: this.state.inputKey, onChange: this.handleSearch }),
                            React.createElement("a", { class: "icon-search filter-product-a" })),
                        productList,
                        React.createElement("li", { className: "browse-eol-area" },
                            React.createElement("div", { style: { "display": "flex" } },
                                React.createElement("span", { style: { "minWidth": 0, "width": "34px", "fontSize": "24px" }, className: "icon-l-service" }),
                                React.createElement("span", { style: { "minWidth": 0, "cursor": "auto" }, dangerouslySetInnerHTML: { __html: this.noProductResultMoreText() } }))))));
            }
            if (this.props.slickType === SlickType.Series || this.props.slickType === SlickType.SubSeries) {
                return (React.createElement("div", { className: "wrapper-dropdown" },
                    React.createElement("span", null, this.state.currentType)));
            }
            else if (this.props.slickType === SlickType.MT) {
                return (React.createElement("div", null));
            }
        }
    });
    var render = function () {
        ReactDOM.render(React.createElement("div", { className: "content center ps-browse" },
            React.createElement(SlickList, { slickType: SlickType.Types }),
            React.createElement("div", { className: "dropdown-group" },
                React.createElement(DownloadList, { slickType: SlickType.Series, tabName: redirctTabName, tabSubUrl: redirctTabSubUrl }),
                React.createElement(DownloadList, { slickType: SlickType.SubSeries, tabName: redirctTabName, tabSubUrl: redirctTabSubUrl }),
                React.createElement(DownloadList, { slickType: SlickType.MT, tabName: redirctTabName, tabSubUrl: redirctTabSubUrl }))), element);
    };
    return {
        render: render
    };
};
exports.load = function (element, browserType, redirctTabName, redirctTabSubUrl) {
    if (redirctTabName === void 0) { redirctTabName = ""; }
    if (redirctTabSubUrl === void 0) { redirctTabSubUrl = ""; }
    l.Content.getAllProductsForBrowseAsync(null, function (data) {
        app = bsApp(data);
        var render = bsRender(element, browserType, redirctTabName, redirctTabSubUrl);
        render.render();
    });
};
exports.reset = function () {
    app.reset();
    $('.dropdown-group').slideUp();
};
